webpackJsonp([1,0],[
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _vue = __webpack_require__(56);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _App = __webpack_require__(41);
	
	var _App2 = _interopRequireDefault(_App);
	
	var _vueRouter = __webpack_require__(55);
	
	var _vueRouter2 = _interopRequireDefault(_vueRouter);
	
	var _Portfolio = __webpack_require__(44);
	
	var _Portfolio2 = _interopRequireDefault(_Portfolio);
	
	var _About = __webpack_require__(42);
	
	var _About2 = _interopRequireDefault(_About);
	
	var _Contact = __webpack_require__(43);
	
	var _Contact2 = _interopRequireDefault(_Contact);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_vue2.default.use(_vueRouter2.default);
	
	var routes = [{ path: '/portfolio', component: _Portfolio2.default, alias: '/' }, { path: '/about', component: _About2.default }, { path: '/contact', component: _Contact2.default }];
	
	var router = new _vueRouter2.default({
	  routes: routes,
	  mode: 'history',
	  scrollBehavior: function scrollBehavior(to, from, savedPosition) {
	    if (savedPosition) {
	      return savedPosition;
	    } else if (to.hash) {
	      return {
	        selector: to.hash
	      };
	    } else {
	      return { x: 0, y: 0 };
	    }
	  }
	});
	
	new _vue2.default({
	  el: '#app',
	  template: '<App/>',
	  components: { App: _App2.default },
	  router: router
	});

/***/ },
/* 1 */,
/* 2 */,
/* 3 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.minThrottle = undefined;
	
	var _timeout = __webpack_require__(7);
	
	var _timeout2 = _interopRequireDefault(_timeout);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var throttle = function throttle(waitMs) {
	  return function (func) {
	    return function () {
	      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	        args[_key] = arguments[_key];
	      }
	
	      return !_timeout2.default.pending(func) && _timeout2.default.set(func, function () {}, waitMs) ? func.apply(undefined, args) : null;
	    };
	  };
	};
	
	exports.default = throttle;
	var minThrottle = exports.minThrottle = throttle(5);

/***/ },
/* 4 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	
	var atvImg = function atvImg() {
		var d = document,
		    de = d.documentElement,
		    bd = d.getElementsByTagName('body')[0],
		    htm = d.getElementsByTagName('html')[0],
		    win = window,
		    imgs = d.querySelectorAll('.atvImg'),
		    totalImgs = imgs.length,
		    supportsTouch = 'ontouchstart' in win || navigator.msMaxTouchPoints;
	
		if (totalImgs <= 0) {
			return;
		}
	
		for (var l = 0; l < totalImgs; l++) {
	
			var thisImg = imgs[l],
			    layerElems = thisImg.querySelectorAll('.atvImg-layer'),
			    totalLayerElems = layerElems.length;
	
			if (totalLayerElems <= 0) {
				continue;
			}
	
			while (thisImg.firstChild) {
				thisImg.removeChild(thisImg.firstChild);
			}
	
			var containerHTML = d.createElement('div'),
			    shineHTML = d.createElement('div'),
			    shadowHTML = d.createElement('div'),
			    layersHTML = d.createElement('div'),
			    layers = [];
	
			thisImg.id = 'atvImg__' + l;
			containerHTML.className = 'atvImg-container';
			shineHTML.className = 'atvImg-shine';
			shadowHTML.className = 'atvImg-shadow';
			layersHTML.className = 'atvImg-layers';
	
			for (var i = 0; i < totalLayerElems; i++) {
				var layer = d.createElement('div'),
				    imgSrc = layerElems[i].getAttribute('data-img');
	
				layer.className = 'atvImg-rendered-layer';
				layer.setAttribute('data-layer', i);
				layer.style.backgroundImage = 'url(' + imgSrc + ')';
				layersHTML.appendChild(layer);
	
				layers.push(layer);
			}
	
			containerHTML.appendChild(shadowHTML);
			containerHTML.appendChild(layersHTML);
			containerHTML.appendChild(shineHTML);
			thisImg.appendChild(containerHTML);
	
			var w = thisImg.clientWidth || thisImg.offsetWidth || thisImg.scrollWidth;
			thisImg.style.transform = 'perspective(' + w * 3 + 'px)';
	
			if (supportsTouch) {
				win.preventScroll = false;
	
				(function (_thisImg, _layers, _totalLayers, _shine) {
					thisImg.addEventListener('touchmove', function (e) {
						if (win.preventScroll) {
							e.preventDefault();
						}
						processMovement(e, true, _thisImg, _layers, _totalLayers, _shine);
					});
					thisImg.addEventListener('touchstart', function (e) {
						win.preventScroll = true;
						processEnter(e, _thisImg);
					});
					thisImg.addEventListener('touchend', function (e) {
						win.preventScroll = false;
						processExit(e, _thisImg, _layers, _totalLayers, _shine);
					});
				})(thisImg, layers, totalLayerElems, shineHTML);
			} else {
				(function (_thisImg, _layers, _totalLayers, _shine) {
					thisImg.addEventListener('mousemove', function (e) {
						processMovement(e, false, _thisImg, _layers, _totalLayers, _shine);
					});
					thisImg.addEventListener('mouseenter', function (e) {
						processEnter(e, _thisImg);
					});
					thisImg.addEventListener('mouseleave', function (e) {
						processExit(e, _thisImg, _layers, _totalLayers, _shine);
					});
				})(thisImg, layers, totalLayerElems, shineHTML);
			}
		}
	
		function processMovement(e, touchEnabled, elem, layers, totalLayers, shine) {
	
			var bdst = bd.scrollTop || htm.scrollTop,
			    bdsl = bd.scrollLeft,
			    pageX = touchEnabled ? e.touches[0].pageX : e.pageX,
			    pageY = touchEnabled ? e.touches[0].pageY : e.pageY,
			    offsets = elem.getBoundingClientRect(),
			    w = elem.clientWidth || elem.offsetWidth || elem.scrollWidth,
			    h = elem.clientHeight || elem.offsetHeight || elem.scrollHeight,
			    wMultiple = 320 / w,
			    offsetX = 0.52 - (pageX - offsets.left - bdsl) / w,
			    offsetY = 0.52 - (pageY - offsets.top - bdst) / h,
			    dy = pageY - offsets.top - bdst - h / 2,
			    dx = pageX - offsets.left - bdsl - w / 2,
			    yRotate = (offsetX - dx) * (0.07 * wMultiple),
			    xRotate = (dy - offsetY) * (0.1 * wMultiple),
			    imgCSS = 'rotateX(' + xRotate + 'deg) rotateY(' + yRotate + 'deg)',
			    arad = Math.atan2(dy, dx),
			    angle = arad * 180 / Math.PI - 90;
			if (angle < 0) {
				angle = angle + 360;
			}
	
			if (elem.firstChild.className.indexOf(' over') != -1) {
				imgCSS += ' scale3d(1.07,1.07,1.07)';
			}
			elem.firstChild.style.transform = imgCSS;
	
			shine.style.background = 'linear-gradient(' + angle + 'deg, rgba(255,255,255,' + (pageY - offsets.top - bdst) / h * 0.4 + ') 0%,rgba(255,255,255,0) 80%)';
			shine.style.transform = 'translateX(' + offsetX * totalLayers - 0.1 + 'px) translateY(' + offsetY * totalLayers - 0.1 + 'px)';
	
			var revNum = totalLayers;
			for (var ly = 0; ly < totalLayers; ly++) {
				layers[ly].style.transform = 'translateX(' + offsetX * revNum * (ly * 2.5 / wMultiple) + 'px) translateY(' + offsetY * totalLayers * (ly * 2.5 / wMultiple) + 'px)';
				revNum--;
			}
		}
	
		function processEnter(e, elem) {
			elem.firstChild.className += ' over';
		}
	
		function processExit(e, elem, layers, totalLayers, shine) {
	
			var container = elem.firstChild;
	
			container.className = container.className.replace(' over', '');
			container.style.transform = '';
			shine.style.cssText = '';
	
			for (var ly = 0; ly < totalLayers; ly++) {
				layers[ly].style.transform = '';
			}
		}
	};
	
	exports.default = atvImg;

/***/ },
/* 5 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _jquery = __webpack_require__(2);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var arPersist = function () {
	  var els = [];
	
	  var add = function add(el) {
	    var $el = (0, _jquery2.default)(el);
	
	    var ar = $el.data('ar');
	
	    if (!ar) {
	      ar = $el.height() / $el.width();
	    }
	
	    els.push({
	      el: el,
	      ar: ar
	    });
	
	    update(els.length - 1);
	  };
	
	  var update = function update(index) {
	    els.forEach(function (_ref, i) {
	      var el = _ref.el,
	          ar = _ref.ar;
	
	      if (typeof index === 'undefined' || index === i) {
	        var $el = (0, _jquery2.default)(el);
	        var newH = $el.width() * ar;
	
	        $el.height(newH);
	      }
	    });
	  };
	
	  return {
	    add: add,
	    update: update
	  };
	}();
	
	exports.default = arPersist;

/***/ },
/* 6 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.updateState = exports.isScrolled = exports.hasTouch = undefined;
	
	var _jquery = __webpack_require__(2);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var hasTouch = exports.hasTouch = 'ontouchstart' in window || window.DocumentTouch && document instanceof window.DocumentTouch;
	
	var isScrolled = exports.isScrolled = function isScrolled() {
	  return (0, _jquery2.default)(window).scrollTop() > 0;
	};
	
	var updateState = exports.updateState = function updateState(className, enabled) {
	  (0, _jquery2.default)('html').toggleClass(className, enabled).toggleClass('no-' + className, !enabled);
	};

/***/ },
/* 7 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var timeout = function () {
	  var keyId = {};
	  var complete = {};
	
	  var set = function set() {
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    var key = void 0,
	        func = void 0,
	        ms = void 0;
	
	    if (args.length === 3) {
	      key = args[0];
	      func = args[1];
	      ms = args[2];
	    } else {
	      func = args[0];
	      ms = args[1];
	
	      key = func;
	    }
	
	    var invoke = function invoke() {
	      complete[key] = true;
	      return func();
	    };
	
	    keyId[key] = setTimeout(invoke, ms);
	    complete[key] = false;
	
	    return function () {
	      return executed(key);
	    };
	  };
	
	  var clear = function clear(key) {
	    clearTimeout(keyId[key]);
	    delete keyId[key];
	    delete complete[key];
	  };
	
	  var exists = function exists(key) {
	    return key in keyId;
	  };
	
	  var pending = function pending(key) {
	    return exists(key) && !executed(key);
	  };
	
	  var executed = function executed(key) {
	    return key in complete && complete[key];
	  };
	
	  return {
	    set: set,
	    clear: clear,
	    exists: exists,
	    pending: pending,
	    executed: executed
	  };
	}();
	
	exports.default = timeout;

/***/ },
/* 8 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _throttle = __webpack_require__(3);
	
	var _detect = __webpack_require__(6);
	
	__webpack_require__(15);
	
	var _jquery = __webpack_require__(2);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _SiteHeader = __webpack_require__(47);
	
	var _SiteHeader2 = _interopRequireDefault(_SiteHeader);
	
	var _SiteFooter = __webpack_require__(46);
	
	var _SiteFooter2 = _interopRequireDefault(_SiteFooter);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'app',
	
	  components: {
	    SiteHeader: _SiteHeader2.default,
	    SiteFooter: _SiteFooter2.default
	  },
	
	  beforeCreate: function beforeCreate() {
	    (0, _detect.updateState)('touch', _detect.hasTouch);
	    (0, _detect.updateState)('mouse', false);
	
	    var touching = false;
	    var mouseEnters = 0;
	    var mouseMoves = 0;
	    var clicks = 0;
	    (0, _jquery2.default)('body').bind('touchstart.detect', function () {
	      touching = true;
	    }).bind('touchend.detect', function () {
	      touching = false;
	    }).bind('click.detect', function () {
	      if (mouseMoves >= 0 && mouseMoves <= clicks) {
	        (0, _jquery2.default)('body').unbind('.detect');
	      }
	    }).bind('mousedown.detect', function () {
	      console.log('mousedown');--mouseMoves;++clicks;
	    }).bind('mouseenter.detect', function (event) {
	      ++mouseEnters;
	      mouseMoves = 0;
	    }).bind('mousemove.detect', function () {
	      ++mouseMoves;
	
	      if (mouseEnters < mouseMoves && !touching) {
	        (0, _detect.updateState)('mouse', true);
	
	        (0, _jquery2.default)('body').unbind('.detect');
	      } else if (clicks === 0 && mouseEnters === 1 && mouseMoves === 0) {
	        (0, _jquery2.default)('body').unbind('.detect');
	      }
	
	      clicks > 0 && --clicks;
	    });
	  },
	  mounted: function mounted() {
	    this.routeUpdated(this.$route.path);
	
	    this.initScroll();
	  },
	
	
	  watch: {
	    '$route': function $route(to, from) {
	      this.routeUpdated(to.path, from.path);
	    }
	  },
	
	  methods: {
	    routeUpdated: function routeUpdated(to, from) {
	      var format = function format(s) {
	        return s === '/' ? 'portfolio' : s.substring(1).replace(/\//g, '-');
	      };
	
	      var toClass = to ? format(to) : '';
	      var fromClass = from ? format(from) : '';
	
	      toClass !== '' && (0, _jquery2.default)('html').addClass('page-' + toClass);
	      fromClass !== '' && (0, _jquery2.default)('html').removeClass('page-' + fromClass);
	    },
	    initScroll: function initScroll() {
	      (0, _jquery2.default)(window).scroll((0, _throttle.minThrottle)(function (event) {
	        (0, _detect.updateState)('scroll', (0, _detect.isScrolled)());
	      })).scroll();
	    }
	  }
	};

/***/ },
/* 9 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _atvImg = __webpack_require__(4);
	
	var _atvImg2 = _interopRequireDefault(_atvImg);
	
	var _jquery = __webpack_require__(2);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	__webpack_require__(24);
	
	exports.default = {
	  name: 'about',
	
	  mounted: function mounted() {
	    (0, _jquery2.default)(document).ready(function () {
	      (0, _atvImg2.default)();
	    });
	  },
	
	
	  methods: {
	    getHeadshotLayer: function getHeadshotLayer(layer) {
	      return __webpack_require__(57)("./headshot-" + layer + '.png');
	    }
	  }
	};

/***/ },
/* 10 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'contact'
	};

/***/ },
/* 11 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _PortfolioItem = __webpack_require__(45);
	
	var _PortfolioItem2 = _interopRequireDefault(_PortfolioItem);
	
	var _jquery = __webpack_require__(2);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'portfolio',
	
	  components: {
	    PortfolioItem: _PortfolioItem2.default
	  },
	
	  mounted: function mounted() {
	    this.initPreviewer();
	  },
	  data: function data() {
	    return {
	      portfoliolist: [{
	        id: '11pelicanvista.com',
	        title: '11 Pelican Vista',
	        desc: 'Media-heavy responsive Web app platform showcasing luxury real estate listings. ' + 'Single-handedly designed and implemented entire system from scratch.',
	        url: 'https://mwa.propcard.com/profile/mwa/propcard/11-pelican-vista'
	      }, {
	        id: 'bankofamerica',
	        title: 'Bank of America',
	        desc: 'Implemented entire front-end for new real estate search interface - responsive and ADA-compliant.',
	        url: 'https://realestatecenter.bankofamerica.com'
	      }, {
	        id: 'http://edwecate.com',
	        title: 'edWEcate',
	        desc: 'Exploratory site built entirely with AngularJS (v1) primarily as a learning exercise.'
	      }, {
	        id: 'https://gdurl.com',
	        title: 'gd URL',
	        desc: 'Public service providing direct, permanent links to files stored at Google Drive.'
	      }, {
	        id: 'https://web.archive.org/web/20160314055132/http://homgroup.com/',
	        title: 'HOM Group',
	        desc: 'Luxury real estate brokerage management system, MLS pull, and listing search. ' + 'Single-handedly designed and implemented entire system from scratch.'
	      }, {
	        id: 'hyperloop',
	        title: 'Hyperloop-One',
	        desc: 'Offline micro-site for Hyperloop presentation on 80"x60" touch-interactive tabletop. ' + 'Built single-handedly using VueJS. (View in browser at 800x600.)',
	        url: 'http://hyperloop.rommelsantor.com'
	      }, {
	        id: 'https://imagehotspotter.com',
	        title: 'Image HotSpotter',
	        desc: 'Commercial WordPress plugin for creating responsive interactive collection of image hotspots.'
	      }, {
	        id: 'nationstar',
	        title: 'NationStar Mortgage',
	        desc: 'Implemented entire front-end for new real estate search interface - responsive and ADA-compliant.',
	        url: 'https://mrcooper.xome.com'
	      }, {
	        id: 'https://www.neatorama.com',
	        title: 'Neatorama',
	        desc: 'High-traffic blog required custom platform built to replace WordPress for more specialized functionality. ' + 'Single-handedly designed and implemented entire system from scratch.'
	      }, {
	        id: 'https://www.neatoshop.com',
	        title: 'Neato Shop',
	        desc: 'Custom, fully-featured e-commerce platform built to support extensive customizations. ' + 'Single-handedly designed and implemented entire system from scratch.'
	      }, {
	        id: 'https://onedown.io',
	        title: 'One Down',
	        desc: 'One-time-download private file relay service. Still barebones with many more features yet to be implemented.'
	      }, {
	        id: 'https://videosift.com',
	        title: 'Video Sift',
	        desc: 'Online-video voting and sharing community. Single-handedly built framework and CMS from scratch.'
	      }]
	    };
	  },
	
	
	  computed: {},
	
	  methods: {
	    initPreviewer: function initPreviewer() {
	      (0, _jquery2.default)('.portfolio-item a').click(function (event) {
	        if (!(0, _jquery2.default)('html').hasClass('no-mouse')) {
	          return;
	        }
	
	        if (!(0, _jquery2.default)(this).hasClass('preview')) {
	          event.preventDefault();
	
	          (0, _jquery2.default)('.portfolio-item .preview').removeClass('preview');
	          (0, _jquery2.default)(this).addClass('preview');
	        }
	      });
	    }
	  }
	};

/***/ },
/* 12 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _arPersist = __webpack_require__(5);
	
	var _arPersist2 = _interopRequireDefault(_arPersist);
	
	var _throttle = __webpack_require__(3);
	
	var _jquery = __webpack_require__(2);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'portfolio-item',
	
	  props: ['id', 'title', 'desc', 'url'],
	
	  created: function created() {
	    this.initBgImage();
	  },
	  mounted: function mounted() {
	    this.initResize();
	  },
	  data: function data() {
	    return {};
	  },
	
	
	  methods: {
	    initBgImage: function initBgImage() {
	      var imgurl = __webpack_require__(58)("./" + this.id + '.jpg');
	      this.bgstyle = 'background-image: url(\'' + imgurl + '\')';
	    },
	    initResize: function initResize() {
	      (0, _jquery2.default)(window).resize((0, _throttle.minThrottle)(function () {
	        return _arPersist2.default.update();
	      }));
	
	      _arPersist2.default.add(this.$el);
	    }
	  }
	};

/***/ },
/* 13 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'site-footer'
	};

/***/ },
/* 14 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'site-header',
	  data: function data() {
	    return {
	      msg: 'Welcome to Your Vue.js App'
	    };
	  }
	};

/***/ },
/* 15 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(!(function webpackMissingModule() { var e = new Error("Cannot find module \"!!./../../node_modules/css-loader/index.js?sourceMap!./../../node_modules/sass-loader/index.js?sourceMap!./global.scss\""); e.code = 'MODULE_NOT_FOUND'; throw e; }()));
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(1)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!./../../node_modules/css-loader/index.js?sourceMap!./../../node_modules/sass-loader/index.js?sourceMap!./global.scss", function() {
				var newContent = require("!!./../../node_modules/css-loader/index.js?sourceMap!./../../node_modules/sass-loader/index.js?sourceMap!./global.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 16 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(!(function webpackMissingModule() { var e = new Error("Cannot find module \"!!./../../node_modules/css-loader/index.js?sourceMap!./../../node_modules/vue-loader/lib/style-rewriter.js?id=data-v-14c4a71a&scoped=true!./../../node_modules/sass-loader/index.js?sourceMap!./../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./SiteHeader.vue\""); e.code = 'MODULE_NOT_FOUND'; throw e; }()));
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(1)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!./../../node_modules/css-loader/index.js?sourceMap!./../../node_modules/vue-loader/lib/style-rewriter.js?id=data-v-14c4a71a&scoped=true!./../../node_modules/sass-loader/index.js?sourceMap!./../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./SiteHeader.vue", function() {
				var newContent = require("!!./../../node_modules/css-loader/index.js?sourceMap!./../../node_modules/vue-loader/lib/style-rewriter.js?id=data-v-14c4a71a&scoped=true!./../../node_modules/sass-loader/index.js?sourceMap!./../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./SiteHeader.vue");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 17 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(!(function webpackMissingModule() { var e = new Error("Cannot find module \"!!./../../node_modules/css-loader/index.js?sourceMap!./../../node_modules/vue-loader/lib/style-rewriter.js?id=data-v-1831884e!./../../node_modules/sass-loader/index.js?sourceMap!./../../node_modules/vue-loader/lib/selector.js?type=styles&index=1!./Portfolio.vue\""); e.code = 'MODULE_NOT_FOUND'; throw e; }()));
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(1)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!./../../node_modules/css-loader/index.js?sourceMap!./../../node_modules/vue-loader/lib/style-rewriter.js?id=data-v-1831884e!./../../node_modules/sass-loader/index.js?sourceMap!./../../node_modules/vue-loader/lib/selector.js?type=styles&index=1!./Portfolio.vue", function() {
				var newContent = require("!!./../../node_modules/css-loader/index.js?sourceMap!./../../node_modules/vue-loader/lib/style-rewriter.js?id=data-v-1831884e!./../../node_modules/sass-loader/index.js?sourceMap!./../../node_modules/vue-loader/lib/selector.js?type=styles&index=1!./Portfolio.vue");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 18 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(!(function webpackMissingModule() { var e = new Error("Cannot find module \"!!./../../node_modules/css-loader/index.js?sourceMap!./../../node_modules/vue-loader/lib/style-rewriter.js?id=data-v-1831884e&scoped=true!./../../node_modules/sass-loader/index.js?sourceMap!./../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./Portfolio.vue\""); e.code = 'MODULE_NOT_FOUND'; throw e; }()));
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(1)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!./../../node_modules/css-loader/index.js?sourceMap!./../../node_modules/vue-loader/lib/style-rewriter.js?id=data-v-1831884e&scoped=true!./../../node_modules/sass-loader/index.js?sourceMap!./../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./Portfolio.vue", function() {
				var newContent = require("!!./../../node_modules/css-loader/index.js?sourceMap!./../../node_modules/vue-loader/lib/style-rewriter.js?id=data-v-1831884e&scoped=true!./../../node_modules/sass-loader/index.js?sourceMap!./../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./Portfolio.vue");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 19 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(!(function webpackMissingModule() { var e = new Error("Cannot find module \"!!./../../node_modules/css-loader/index.js?sourceMap!./../../node_modules/vue-loader/lib/style-rewriter.js?id=data-v-2d0cd7c4&scoped=true!./../../node_modules/sass-loader/index.js?sourceMap!./../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./About.vue\""); e.code = 'MODULE_NOT_FOUND'; throw e; }()));
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(1)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!./../../node_modules/css-loader/index.js?sourceMap!./../../node_modules/vue-loader/lib/style-rewriter.js?id=data-v-2d0cd7c4&scoped=true!./../../node_modules/sass-loader/index.js?sourceMap!./../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./About.vue", function() {
				var newContent = require("!!./../../node_modules/css-loader/index.js?sourceMap!./../../node_modules/vue-loader/lib/style-rewriter.js?id=data-v-2d0cd7c4&scoped=true!./../../node_modules/sass-loader/index.js?sourceMap!./../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./About.vue");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 20 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(!(function webpackMissingModule() { var e = new Error("Cannot find module \"!!./../../node_modules/css-loader/index.js?sourceMap!./../../node_modules/vue-loader/lib/style-rewriter.js?id=data-v-57296efe&scoped=true!./../../node_modules/sass-loader/index.js?sourceMap!./../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./SiteFooter.vue\""); e.code = 'MODULE_NOT_FOUND'; throw e; }()));
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(1)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!./../../node_modules/css-loader/index.js?sourceMap!./../../node_modules/vue-loader/lib/style-rewriter.js?id=data-v-57296efe&scoped=true!./../../node_modules/sass-loader/index.js?sourceMap!./../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./SiteFooter.vue", function() {
				var newContent = require("!!./../../node_modules/css-loader/index.js?sourceMap!./../../node_modules/vue-loader/lib/style-rewriter.js?id=data-v-57296efe&scoped=true!./../../node_modules/sass-loader/index.js?sourceMap!./../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./SiteFooter.vue");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 21 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(!(function webpackMissingModule() { var e = new Error("Cannot find module \"!!./../../node_modules/css-loader/index.js?sourceMap!./../../node_modules/vue-loader/lib/style-rewriter.js?id=data-v-63f0d10c&scoped=true!./../../node_modules/sass-loader/index.js?sourceMap!./../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./PortfolioItem.vue\""); e.code = 'MODULE_NOT_FOUND'; throw e; }()));
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(1)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!./../../node_modules/css-loader/index.js?sourceMap!./../../node_modules/vue-loader/lib/style-rewriter.js?id=data-v-63f0d10c&scoped=true!./../../node_modules/sass-loader/index.js?sourceMap!./../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./PortfolioItem.vue", function() {
				var newContent = require("!!./../../node_modules/css-loader/index.js?sourceMap!./../../node_modules/vue-loader/lib/style-rewriter.js?id=data-v-63f0d10c&scoped=true!./../../node_modules/sass-loader/index.js?sourceMap!./../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./PortfolioItem.vue");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 22 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(!(function webpackMissingModule() { var e = new Error("Cannot find module \"!!./../../node_modules/css-loader/index.js?sourceMap!./../../node_modules/vue-loader/lib/style-rewriter.js?id=data-v-73e1d8f1&scoped=true!./../../node_modules/sass-loader/index.js?sourceMap!./../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./Contact.vue\""); e.code = 'MODULE_NOT_FOUND'; throw e; }()));
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(1)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!./../../node_modules/css-loader/index.js?sourceMap!./../../node_modules/vue-loader/lib/style-rewriter.js?id=data-v-73e1d8f1&scoped=true!./../../node_modules/sass-loader/index.js?sourceMap!./../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./Contact.vue", function() {
				var newContent = require("!!./../../node_modules/css-loader/index.js?sourceMap!./../../node_modules/vue-loader/lib/style-rewriter.js?id=data-v-73e1d8f1&scoped=true!./../../node_modules/sass-loader/index.js?sourceMap!./../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./Contact.vue");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 23 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(!(function webpackMissingModule() { var e = new Error("Cannot find module \"!!./../node_modules/css-loader/index.js?sourceMap!./../node_modules/vue-loader/lib/style-rewriter.js?id=data-v-b82d32f2!./../node_modules/sass-loader/index.js?sourceMap!./../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./App.vue\""); e.code = 'MODULE_NOT_FOUND'; throw e; }()));
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(1)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!./../node_modules/css-loader/index.js?sourceMap!./../node_modules/vue-loader/lib/style-rewriter.js?id=data-v-b82d32f2!./../node_modules/sass-loader/index.js?sourceMap!./../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./App.vue", function() {
				var newContent = require("!!./../node_modules/css-loader/index.js?sourceMap!./../node_modules/vue-loader/lib/style-rewriter.js?id=data-v-b82d32f2!./../node_modules/sass-loader/index.js?sourceMap!./../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./App.vue");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 24 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 25 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/headshot-1.f4033b4.png";

/***/ },
/* 26 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ },
/* 27 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ },
/* 28 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/headshot.e5fd276.png";

/***/ },
/* 29 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/11pelicanvista.com.319ab3d.jpg";

/***/ },
/* 30 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/bankofamerica.1cd7378.jpg";

/***/ },
/* 31 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/edwecate.com.0a9d379.jpg";

/***/ },
/* 32 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/gdurl.com.058d065.jpg";

/***/ },
/* 33 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/homgroup.com.1b18d86.jpg";

/***/ },
/* 34 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/hyperloop.5fa4319.jpg";

/***/ },
/* 35 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/imagehotspotter.com.fc5272b.jpg";

/***/ },
/* 36 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/nationstar.a2d902f.jpg";

/***/ },
/* 37 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/neatorama.com.97643ae.jpg";

/***/ },
/* 38 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/neatoshop.com.53620f1.jpg";

/***/ },
/* 39 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/onedown.io.b557f23.jpg";

/***/ },
/* 40 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/videosift.com.bc393ba.jpg";

/***/ },
/* 41 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(23)
	
	/* script */
	__vue_exports__ = __webpack_require__(8)
	
	/* template */
	var __vue_template__ = __webpack_require__(54)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 42 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(19)
	
	/* script */
	__vue_exports__ = __webpack_require__(9)
	
	/* template */
	var __vue_template__ = __webpack_require__(50)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-2d0cd7c4"
	
	module.exports = __vue_exports__


/***/ },
/* 43 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(22)
	
	/* script */
	__vue_exports__ = __webpack_require__(10)
	
	/* template */
	var __vue_template__ = __webpack_require__(53)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-73e1d8f1"
	
	module.exports = __vue_exports__


/***/ },
/* 44 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(18)
	__webpack_require__(17)
	
	/* script */
	__vue_exports__ = __webpack_require__(11)
	
	/* template */
	var __vue_template__ = __webpack_require__(49)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-1831884e"
	
	module.exports = __vue_exports__


/***/ },
/* 45 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(21)
	
	/* script */
	__vue_exports__ = __webpack_require__(12)
	
	/* template */
	var __vue_template__ = __webpack_require__(52)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-63f0d10c"
	
	module.exports = __vue_exports__


/***/ },
/* 46 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(20)
	
	/* script */
	__vue_exports__ = __webpack_require__(13)
	
	/* template */
	var __vue_template__ = __webpack_require__(51)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-57296efe"
	
	module.exports = __vue_exports__


/***/ },
/* 47 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(16)
	
	/* script */
	__vue_exports__ = __webpack_require__(14)
	
	/* template */
	var __vue_template__ = __webpack_require__(48)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-14c4a71a"
	
	module.exports = __vue_exports__


/***/ },
/* 48 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
	  return _h('div', {
	    attrs: {
	      "id": "site-header"
	    }
	  }, [_vm._m(0), " ", _h('nav', {
	    attrs: {
	      "id": "site-nav"
	    }
	  }, [_h('ul', [_h('li', [_h('router-link', {
	    attrs: {
	      "to": "/",
	      "exact": ""
	    }
	  }, ["Portfolio"])]), " ", _h('li', [_h('router-link', {
	    attrs: {
	      "to": "/about"
	    }
	  }, ["About Me"])]), " ", _h('li', [_h('router-link', {
	    attrs: {
	      "to": "/contact"
	    }
	  }, ["Contact"])])])])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;
	  return _h('header', [_h('h1', ["Rommel Santor"]), " ", _h('h2', ["Web Developer"])])
	}]}

/***/ },
/* 49 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
	  return _h('section', {
	    attrs: {
	      "id": "portfolio"
	    }
	  }, [_h('p', ["\n    This is a list in alphabetical order of some recent and/or notable projects.\n    Most of them I developed single-handedly; for the rest I was principal developer.\n  "]), " ", _vm._l((_vm.portfoliolist), function(item) {
	    return _h('portfolio-item', {
	      attrs: {
	        "id": item.id,
	        "title": item.title,
	        "desc": item.desc,
	        "url": item.url || item.id
	      }
	    })
	  })])
	},staticRenderFns: []}

/***/ },
/* 50 */
/***/ function(module, exports, __webpack_require__) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
	  return _h('section', {
	    attrs: {
	      "id": "about"
	    }
	  }, [_h('div', {
	    staticClass: "bio-container"
	  }, [_h('div', {
	    staticClass: "headshot"
	  }, [_h('img', {
	    attrs: {
	      "src": __webpack_require__(28)
	    }
	  }), " ", (false) ? _h('div', {
	    staticClass: "atvImg"
	  }, [_h('img', {
	    attrs: {
	      "src": require("../assets/headshot.png")
	    }
	  }), " ", _h('div', {
	    staticClass: "atvImg-layer",
	    attrs: {
	      "data-img": _vm.getHeadshotLayer(3)
	    }
	  }), " ", _h('div', {
	    staticClass: "atvImg-layer",
	    attrs: {
	      "data-img": _vm.getHeadshotLayer(2)
	    }
	  }), " ", _h('div', {
	    staticClass: "atvImg-layer",
	    attrs: {
	      "data-img": _vm.getHeadshotLayer(1)
	    }
	  })]) : _vm._e()]), " ", _vm._m(0)])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;
	  return _h('div', {
	    staticClass: "bio"
	  }, [_h('h3', ["Beginnings"]), " ", _h('p', ["\n        Despite how uncommon personal computers were when I was a child, I was fascinated\n        by the idea of using them to create programs that do things. As I grew up I always\n        had the dream of creating things on computers, though I never actually had a computer\n        until I was 18 years old. Once I did, though, I spent my days and nights teaching\n        myself to bring my dream to life, eventually graduating Cum Laude with a B.S. in\n        Computer Science and turning my passion into my career.\n      "]), " ", _h('h3', ["Expertise"]), " ", _h('p', ["\n        I have spent most of my professional career doing what has always been the most fulfilling:\n        designing and implementing from scratch large-scale Web software systems, historically\n        built and maintained entirely myself on a stack including Ubuntu, MySQL, PHP, Nginx, and jQuery.\n      "]), " ", _h('p', ["\n        In the past few years with the massive paradigm shift in front-end development, I have\n        been falling in love all over again, and because of that love, I have been essentially living\n        on the front-end.\n      "]), " ", _h('h3', ["Personal Homepage"]), " ", _h('p', ["\n        I wrote this personal homepage you're currently reading in its entirety with VueJS 2\n        and bundled with Webpack. The source code is available in this GitHub repository:\n\n        ", _h('ul', [_h('li', [_h('a', {
	    attrs: {
	      "href": "https://github.com/rommelsantor/personal-homepage",
	      "target": "_blank"
	    }
	  }, ["Personal Homepage"])])])]), " ", _h('h3', ["On the Web"]), " ", _h('p', ["\n        You can find more about me scattered around the Web, but here are a few locations where\n        I have been spending time recently.\n\n        ", _h('ul', [_h('li', [_h('a', {
	    attrs: {
	      "href": "http://linkedin.com/in/rommelsantor",
	      "target": "_blank"
	    }
	  }, ["LinkedIn"])]), " ", _h('li', [_h('a', {
	    attrs: {
	      "href": "http://github.com/rommelsantor",
	      "target": "_blank"
	    }
	  }, ["GitHub"])]), " ", _h('li', [_h('a', {
	    attrs: {
	      "href": "http://codepen.io/rommelsantor",
	      "target": "_blank"
	    }
	  }, ["CodePen"])]), " ", _h('li', [_h('a', {
	    attrs: {
	      "href": "http://stackoverflow.com/users/2316774/rommel-santor",
	      "target": "_blank"
	    }
	  }, ["StackOverflow"])])])]), " ", _h('p', ["\n        Here are some other code resources that may be of interest, but that are more likely\n        to have a bit of dust on them.\n\n        ", _h('ul', [_h('li', [_h('a', {
	    attrs: {
	      "href": "/clog",
	      "target": "_blank"
	    }
	  }, ["My Coding Blog"])]), " ", _h('li', [_h('a', {
	    attrs: {
	      "href": "/jquery",
	      "target": "_blank"
	    }
	  }, ["My jQuery Plugins"])])])])])
	}]}

/***/ },
/* 51 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
	  return _h('div', {
	    attrs: {
	      "id": "site-footer"
	    }
	  }, [_h('nav', {
	    attrs: {
	      "id": "footer-nav"
	    }
	  }, [_h('ul', [_h('li', [_h('router-link', {
	    attrs: {
	      "to": "/",
	      "exact": ""
	    }
	  }, ["Portfolio"])]), " ", _h('li', [_h('router-link', {
	    attrs: {
	      "to": "/about"
	    }
	  }, ["About Me"])]), " ", _h('li', [_h('router-link', {
	    attrs: {
	      "to": "/contact"
	    }
	  }, ["Contact"])])])]), " ", _h('footer', ["\n    Copyright © 2016 • Rommel Santor\n  "])])
	},staticRenderFns: []}

/***/ },
/* 52 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
	  return _h('div', {
	    staticClass: "portfolio-item",
	    style: (_vm.bgstyle),
	    attrs: {
	      "data-ar": "0.68125"
	    }
	  }, [_h('a', {
	    staticClass: "scrim",
	    attrs: {
	      "href": _vm.url,
	      "target": "_blank"
	    }
	  }, [_h('b', [_vm._s(_vm.title)]), " ", _h('p', ["\n      " + _vm._s(_vm.desc) + "\n    "])])])
	},staticRenderFns: []}

/***/ },
/* 53 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
	  return _vm._m(0)
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;
	  return _h('section', {
	    attrs: {
	      "id": "contact"
	    }
	  }, [_h('p', ["\n    Please feel free to reach out to me via the following address.\n  "]), " ", _h('p', {
	    staticClass: "emad"
	  }, [_h('b', ["\n      rommel\n    "]), " ", _h('br'), "\n    at\n    ", _h('br'), " ", _h('b', ["rommelsantor"]), "\n    dot\n    ", _h('b', ["com"])])])
	}]}

/***/ },
/* 54 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
	  return _h('div', {
	    attrs: {
	      "id": "app"
	    }
	  }, [_h('site-header'), " ", _h('div', {
	    attrs: {
	      "id": "route-container"
	    }
	  }, [_h('transition', {
	    attrs: {
	      "name": "shrink",
	      "mode": "in-out"
	    }
	  }, [_h('router-view')])]), " ", _h('site-footer')])
	},staticRenderFns: []}

/***/ },
/* 55 */,
/* 56 */,
/* 57 */
/***/ function(module, exports, __webpack_require__) {

	var map = {
		"./headshot-1.png": 25,
		"./headshot-2.png": 26,
		"./headshot-3.png": 27
	};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 57;


/***/ },
/* 58 */
/***/ function(module, exports, __webpack_require__) {

	var map = {
		"./11pelicanvista.com.jpg": 29,
		"./bankofamerica.jpg": 30,
		"./edwecate.com.jpg": 31,
		"./gdurl.com.jpg": 32,
		"./homgroup.com.jpg": 33,
		"./hyperloop.jpg": 34,
		"./imagehotspotter.com.jpg": 35,
		"./nationstar.jpg": 36,
		"./neatorama.com.jpg": 37,
		"./neatoshop.com.jpg": 38,
		"./onedown.io.jpg": 39,
		"./videosift.com.jpg": 40
	};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 58;


/***/ }
]);


// WEBPACK FOOTER //
// static/js/app.b5301311bdc03fba0bd9.js